<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('dw.report.commission.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <!-- {{exportLink}}
            <b-btn :href="exportLink" variant="success" target="_blank"><i class="fa fa-download mr-2"></i>{{$t('dw.general.export')}}</b-btn> -->
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="searchTable" keywordPlaceholder="Type to Search" searchAction="getCommissionReport" vuexModule="Dw" type="dw" :filters="filters" :autoSearchFilters="autoSearchFilters" :columns="columns" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITSearchableTable, FITFormCard } from '@/components'
import Vue from 'vue'
import { domain } from '@/api/api.js'
import { mapGetters } from 'vuex'
export default {
  name: 'reportCommission',
  components: {
    FITSearchableTable,
    FITFormCard
  },
  methods: {
    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Dw', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
    setCurrentFilters(val) {
      Vue.set(this, 'currentFilters', val);
      console.debug(val);
    }
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
  },
  data() {
    return {
      currentFilters: {},
      filters: [{
          label: this.$t('dw.general.policyType'),
          key: 'policyType',
          type: 'select',
          default: 'P',
          haveAll: false,
        },
        {
          label: this.$t('dw.general.status'),
          key: 'status',
          type: 'select',
          default: null
        },
        {
          label: this.$t('general.fromDate'),
          key: 'fromDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('general.toDate'),
          key: 'toDate',
          type: 'datetime',
          default: ''
        }
      ],
      columns: [{
          key: 'agentCode',
          label: this.$t('dw.report.performance.agentCode'),
          thClass: ['tableMinWidth120'],
        }, {
          key: 'agentEnglishName',
          label: this.$t('dw.general.agentName'),
          formatter: (row, key, item) => {
            return '<div>' + item.agentEnglishName + '</div>' +
              '<div>' + item.agentChineseName + '</div>'
          }
        },
        {
          key: 'customerCode',
          label: this.$t('dw.report.customer.customerCode'),
          thClass: ['tableMinWidth120']
        },
        {
          key: 'customerEnglishName',
          label: this.$t('dw.report.customer.header'),
          formatter: (row, key, item) => {
            return '<div>' + item.customerEnglishName + '</div>' + '<div>' + item.customerChineseName + '</div>'
          }
        },
        {
          key: 'productCode',
          label: this.$t('dw.report.commission.productCode'),
          thClass: ['tableMinWidth120'],
          formatter: (row, key, item) => {
            return this.$options.filters.isEmpty(row)
          }
        },
        {
          key: 'policyType',
          label: this.$t('dw.report.sale.policyType'),
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
        {
          key: 'productEnglishName',
          label: this.$t('dw.report.sale.productName'),
          formatter: (row, key, item) => {
            return '<div>' + item.productEnglishName + '</div>' + '<div>' + item.productChineseName + '</div>'
          }
        },
        {
          key: 'commission',
          label: this.$t('dw.report.performance.commission'),
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'commissionActualReceived',
          label: this.$t('dw.report.commission.commissionAcutalReceived'),
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'status',
          label: this.$t('dw.general.status'),
          formatter: (row, key, item) => {
            return this.getTranslated(key, row);
          }
        },
      ],
      autoSearchFilters: [{
        label: this.$t('dw.general.agent'),
        key: 'agentID',
        searchParams: {
          placeholder: ' Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: 'agent' }],
          showItems: ['englishFullname', 'chineseFullname']
        }
      }],
    }
  }
}

</script>
<style type="text/css">
.tableMinWidth120 {
  max-width: 120px;
}

.tableMinWidth150 {
  max-width: 150px;
}

.pointer-cursor .table tbody tr,
.pointer-cursor .table tbody td {
  cursor: default !important;
}

</style>



// WEBPACK FOOTER //
// src/Dw/containers/ReportCommission.vue